var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 230,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.795 212.554H72.9549C69.3898 212.554 66.5 209.845 66.5 206.503V44.0502C66.5 40.7086 69.3898 38 72.9549 38H157.795C161.36 38 164.25 40.7086 164.25 44.0502V206.503C164.251 209.845 161.36 212.554 157.795 212.554Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.992 44.9766C116.992 45.8136 116.268 46.4924 115.375 46.4924C114.482 46.4924 113.758 45.8136 113.758 44.9766C113.758 44.1395 114.482 43.4607 115.375 43.4607C116.269 43.4613 116.992 44.1395 116.992 44.9766Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.487 45.6084L132.484 47.7729C131.765 49.3238 130.134 50.3269 128.33 50.3269H102.418C100.614 50.3269 98.9824 49.3238 98.2633 47.7729L97.2601 45.6084C96.5411 44.0575 94.9096 43.0543 93.1055 43.0543H75.1881C73.3679 43.0543 71.8917 44.4379 71.8917 46.144V204.408C71.8917 206.114 73.3672 207.498 75.1881 207.498H155.56C157.38 207.498 158.856 206.115 158.856 204.408V46.144C158.856 44.4379 157.381 43.0543 155.56 43.0543H137.642C135.838 43.0543 134.206 44.0575 133.487 45.6084Z",
    fill: "#1CD490"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 43,
    width: 88,
    height: 165
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.485 45.609L132.481 47.7735C131.762 49.3244 130.131 50.3275 128.327 50.3275H102.415C100.612 50.3275 98.9796 49.3244 98.2605 47.7735L97.2573 45.609C96.5382 44.0581 94.9068 43.0549 93.1027 43.0549H75.1853C73.3651 43.0549 71.8889 44.4385 71.8889 46.1447V204.409C71.8889 206.115 73.3644 207.499 75.1853 207.499H155.557C157.377 207.499 158.854 206.116 158.854 204.409V46.1447C158.854 44.4385 157.378 43.0549 155.557 43.0549H137.639C135.835 43.0549 134.204 44.0581 133.485 45.609Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3831)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.486 45.6087L132.483 47.7732C131.764 49.3241 130.132 50.3273 128.328 50.3273H102.416C100.613 50.3273 98.9809 49.3241 98.2619 47.7732L97.2587 45.6087C96.5396 44.0578 94.9082 43.0547 93.104 43.0547H75.1866C73.3664 43.0547 71.8903 44.4383 71.8903 46.1444V204.409C71.8903 206.115 73.3658 207.498 75.1866 207.498H155.559C157.379 207.498 158.855 206.115 158.855 204.409V46.1444C158.855 44.4383 157.379 43.0547 155.559 43.0547H137.641C135.836 43.0547 134.205 44.0578 133.486 45.6087Z",
    fill: "white",
    stroke: "#1E564D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.487 45.6084L132.484 47.7729C131.765 49.3238 130.134 50.3269 128.33 50.3269H102.418C100.614 50.3269 98.9824 49.3238 98.2633 47.7729L97.2601 45.6084C96.5411 44.0575 94.9096 43.0543 93.1055 43.0543H75.1881C73.3679 43.0543 71.8917 44.4379 71.8917 46.144V204.408C71.8917 206.114 73.3672 207.498 75.1881 207.498H155.56C157.38 207.498 158.856 206.115 158.856 204.408V46.144C158.856 44.4379 157.381 43.0543 155.56 43.0543H137.642C135.838 43.0543 134.206 44.0575 133.487 45.6084Z",
    stroke: "#1E564D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.239 68.1325H77.5095C75.8961 68.1325 74.5887 66.9066 74.5887 65.3949V56.9574C74.5887 55.4451 75.8961 54.2197 77.5095 54.2197H153.239C154.852 54.2197 156.16 55.4457 156.16 56.9574V65.3943C156.16 66.9066 154.852 68.1325 153.239 68.1325Z",
    fill: "white",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.984 61.7073C118.86 60.886 118.86 59.5549 117.984 58.7336C117.108 57.9122 115.688 57.9122 114.811 58.7336C114.029 59.4667 113.947 60.6064 114.563 61.4265C114.511 61.4458 114.462 61.4748 114.42 61.5141L112.237 63.5608C112.072 63.7154 112.072 63.966 112.237 64.1207C112.402 64.2753 112.669 64.2753 112.834 64.1207L115.018 62.0739C115.06 62.0347 115.09 61.9888 115.111 61.9405C115.986 62.5172 117.202 62.4411 117.984 61.7073ZM115.205 61.3389C114.545 60.7211 114.545 59.7198 115.205 59.102C115.864 58.4841 116.932 58.4841 117.591 59.102C118.25 59.7198 118.25 60.7211 117.591 61.3389C116.932 61.9568 115.864 61.9568 115.205 61.3389Z",
    fill: "#1E564D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7387 58.3657H79.0184C78.7072 58.3657 78.4546 58.1289 78.4546 57.8372C78.4546 57.5455 78.7072 57.3088 79.0184 57.3088H87.7387C88.0499 57.3088 88.3025 57.5455 88.3025 57.8372C88.3031 58.1295 88.0505 58.3657 87.7387 58.3657Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6111 61.3933H79.0184C78.7072 61.3933 78.4546 61.1566 78.4546 60.8649C78.4546 60.5732 78.7072 60.3364 79.0184 60.3364H86.6111C86.9223 60.3364 87.1749 60.5732 87.1749 60.8649C87.1749 61.1566 86.9223 61.3933 86.6111 61.3933Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4835 64.4231H79.0184C78.7072 64.4231 78.4546 64.1864 78.4546 63.8947C78.4546 63.603 78.7072 63.3662 79.0184 63.3662H85.4835C85.7947 63.3662 86.0473 63.603 86.0473 63.8947C86.0473 64.1864 85.7947 64.4231 85.4835 64.4231Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.239 115.401H77.5095C75.8961 115.401 74.5887 114.176 74.5887 112.664V74.9881C74.5887 73.4758 75.8961 72.2504 77.5095 72.2504H153.239C154.852 72.2504 156.16 73.4764 156.16 74.9881V112.664C156.16 114.176 154.852 115.401 153.239 115.401Z",
    fill: "white",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.905 77.6756H84.8438V109.978H145.905V77.6756Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.31 97.2478H89.8723C89.3136 97.2478 88.8613 96.8232 88.8613 96.3002C88.8613 95.7766 89.3143 95.3527 89.8723 95.3527H127.31C127.868 95.3527 128.32 95.7772 128.32 96.3002C128.32 96.8232 127.868 97.2478 127.31 97.2478Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.36 101.227H89.8723C89.3136 101.227 88.8613 100.802 88.8613 100.279C88.8613 99.7557 89.3143 99.3311 89.8723 99.3311H124.36C124.918 99.3311 125.371 99.7557 125.371 100.279C125.371 100.803 124.918 101.227 124.36 101.227Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.592 106.555C108.592 107.008 108.199 107.375 107.716 107.375C107.232 107.375 106.84 107.008 106.84 106.555C106.84 106.101 107.232 105.733 107.716 105.733C108.2 105.734 108.592 106.102 108.592 106.555Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.695 106.555C113.695 107.008 113.303 107.375 112.819 107.375C112.335 107.375 111.943 107.008 111.943 106.555C111.943 106.101 112.336 105.733 112.819 105.733C113.302 105.733 113.695 106.102 113.695 106.555Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.803 106.555C118.803 107.008 118.411 107.375 117.928 107.375C117.444 107.375 117.052 107.008 117.052 106.555C117.052 106.101 117.444 105.733 117.928 105.733C118.411 105.734 118.803 106.102 118.803 106.555Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.912 106.555C123.912 107.008 123.519 107.375 123.036 107.375C122.552 107.375 122.161 107.008 122.161 106.555C122.161 106.101 122.553 105.733 123.036 105.733C123.519 105.734 123.912 106.102 123.912 106.555Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.272 97.8091C149.122 97.8091 148.972 97.7626 148.847 97.6678C148.558 97.448 148.513 97.05 148.748 96.7794L151.304 93.8262L148.748 90.8736C148.514 90.6024 148.558 90.2044 148.847 89.9852C149.136 89.7653 149.561 89.807 149.795 90.0776L152.696 93.4288C152.897 93.6607 152.897 93.9929 152.696 94.2248L149.795 97.576C149.662 97.7288 149.468 97.8091 149.272 97.8091Z",
    fill: "#1CD490"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4751 97.8065C81.2792 97.8065 81.0846 97.7268 80.9512 97.5728L78.0498 94.2216C77.8488 93.9896 77.8488 93.6575 78.0498 93.4256L80.9512 90.0743C81.1858 89.8038 81.611 89.7621 81.899 89.9819C82.1883 90.2018 82.2328 90.5998 81.9976 90.8703L79.4409 93.823L81.9976 96.7762C82.2321 97.0474 82.1883 97.4447 81.899 97.6646C81.7753 97.76 81.6245 97.8065 81.4751 97.8065Z",
    fill: "#1CD490"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4057 137.062H81.1422C78.2705 137.062 75.9425 134.88 75.9425 132.188V125.381C75.9425 122.689 78.2705 120.507 81.1422 120.507H88.4051C91.2768 120.507 93.6048 122.689 93.6048 125.381V132.188C93.6048 134.88 91.2768 137.062 88.4057 137.062Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.774 133.884C81.7695 133.884 79.334 131.601 79.334 128.785C79.334 125.969 81.7695 123.686 84.774 123.686C87.7785 123.686 90.2141 125.969 90.2141 128.785C90.2141 131.601 87.7785 133.884 84.774 133.884Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5915 142.056H76.9517C76.3931 142.056 75.9408 141.631 75.9408 141.108C75.9408 140.584 76.3938 140.16 76.9517 140.16H92.5915C93.1501 140.16 93.6024 140.585 93.6024 141.108C93.6024 141.631 93.1501 142.056 92.5915 142.056Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.239 172.382H77.5095C75.8961 172.382 74.5887 171.156 74.5887 169.644V151.15C74.5887 149.638 75.8961 148.413 77.5095 148.413H153.239C154.852 148.413 156.16 149.639 156.16 151.15V169.644C156.16 171.156 154.852 172.382 153.239 172.382Z",
    fill: "white",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.163 152.203H78.6365V168.591H105.163V152.203Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M146.688 154.151H109.25C108.692 154.151 108.239 153.726 108.239 153.203C108.239 152.68 108.692 152.256 109.25 152.256H146.688C147.246 152.256 147.699 152.68 147.699 153.203C147.699 153.727 147.246 154.151 146.688 154.151Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.738 158.132H109.25C108.692 158.132 108.239 157.707 108.239 157.184C108.239 156.66 108.692 156.236 109.25 156.236H143.738C144.296 156.236 144.749 156.661 144.749 157.184C144.749 157.707 144.296 158.132 143.738 158.132Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.677 162.11H109.25C108.692 162.11 108.239 161.685 108.239 161.162C108.239 160.639 108.692 160.215 109.25 160.215H145.677C146.235 160.215 146.688 160.639 146.688 161.162C146.688 161.685 146.235 162.11 145.677 162.11Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.272 166.09H109.25C108.692 166.09 108.239 165.665 108.239 165.142C108.239 164.618 108.692 164.195 109.25 164.195H139.272C139.831 164.195 140.283 164.619 140.283 165.142C140.284 165.666 139.831 166.09 139.272 166.09Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M153.239 200.075H77.5095C75.8961 200.075 74.5887 198.849 74.5887 197.337V178.843C74.5887 177.331 75.8961 176.106 77.5095 176.106H153.239C154.852 176.106 156.16 177.332 156.16 178.843V197.337C156.16 198.849 154.852 200.075 153.239 200.075Z",
    fill: "white",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.163 179.896H78.6365V196.283H105.163V179.896Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.688 181.844H109.25C108.692 181.844 108.239 181.419 108.239 180.896C108.239 180.372 108.692 179.948 109.25 179.948H146.688C147.246 179.948 147.699 180.373 147.699 180.896C147.699 181.419 147.246 181.844 146.688 181.844Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.132 185.822H109.25C108.692 185.822 108.239 185.398 108.239 184.875C108.239 184.351 108.692 183.927 109.25 183.927H149.132C149.69 183.927 150.142 184.352 150.142 184.875C150.143 185.398 149.69 185.822 149.132 185.822Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.632 193.783H109.25C108.692 193.783 108.239 193.358 108.239 192.835C108.239 192.311 108.692 191.887 109.25 191.887H141.632C142.19 191.887 142.642 192.312 142.642 192.835C142.643 193.359 142.19 193.783 141.632 193.783Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.014 189.861H109.25C108.692 189.861 108.239 189.436 108.239 188.913C108.239 188.39 108.692 187.966 109.25 187.966H146.014C146.572 187.966 147.025 188.39 147.025 188.913C147.025 189.437 146.572 189.861 146.014 189.861Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.184 137.062H121.921C119.05 137.062 116.722 134.88 116.722 132.188V125.38C116.722 122.689 119.05 120.507 121.921 120.507H129.184C132.056 120.507 134.384 122.689 134.384 125.38V132.188C134.384 134.88 132.056 137.062 129.184 137.062Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.553 133.884C122.549 133.884 120.113 131.601 120.113 128.785C120.113 125.969 122.549 123.686 125.553 123.686C128.558 123.686 130.993 125.969 130.993 128.785C130.993 131.601 128.558 133.884 125.553 133.884Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.372 142.054H117.733C117.174 142.054 116.722 141.63 116.722 141.107C116.722 140.583 117.175 140.159 117.733 140.159H133.372C133.931 140.159 134.383 140.584 134.383 141.107C134.384 141.63 133.931 142.054 133.372 142.054Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.582 137.062H142.319C139.447 137.062 137.119 134.88 137.119 132.188V125.38C137.119 122.689 139.447 120.507 142.319 120.507H149.582C152.454 120.507 154.782 122.689 154.782 125.38V132.188C154.782 134.88 152.454 137.062 149.582 137.062Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.951 133.884C142.946 133.884 140.511 131.601 140.511 128.785C140.511 125.969 142.946 123.686 145.951 123.686C148.955 123.686 151.391 125.969 151.391 128.785C151.391 131.601 148.955 133.884 145.951 133.884Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.77 142.054H138.13C137.572 142.054 137.119 141.63 137.119 141.107C137.119 140.583 137.572 140.159 138.13 140.159H153.77C154.329 140.159 154.781 140.584 154.781 141.107C154.782 141.63 154.329 142.054 153.77 142.054Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M108.792 137.062H101.529C98.6572 137.062 96.3292 134.88 96.3292 132.188V125.38C96.3292 122.689 98.6572 120.507 101.529 120.507H108.792C111.664 120.507 113.991 122.689 113.991 125.38V132.188C113.991 134.88 111.664 137.062 108.792 137.062Z",
    fill: "#1CD490",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M112.98 142.054H97.3402C96.7815 142.054 96.3292 141.63 96.3292 141.107C96.3292 140.583 96.7822 140.159 97.3402 140.159H112.98C113.539 140.159 113.991 140.584 113.991 141.107C113.991 141.63 113.538 142.054 112.98 142.054Z",
    fill: "#1E564D",
    stroke: "#1E564D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.161 133.884C102.156 133.884 99.7207 131.601 99.7207 128.785C99.7207 125.969 102.156 123.686 105.161 123.686C108.165 123.686 110.601 125.969 110.601 128.785C110.601 131.601 108.165 133.884 105.161 133.884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgMobile);
export default __webpack_public_path__ + "static/media/TgMobile.e5da9b471d848d8c91366b4d9b580bb9.svg";
export { ForwardRef as ReactComponent };